import { render, staticRenderFns } from "./_newDeposit.vue?vue&type=template&id=2c5f3e81&"
import script from "./_newDeposit.vue?vue&type=script&lang=js&"
export * from "./_newDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports